const LOG_LEVELS = { debug: 0, info: 1, warn: 2, error: 3, none: 4 };

const currentLevel =
  process.env.NODE_ENV === 'production' ? LOG_LEVELS.warn : LOG_LEVELS.debug;

const noop = () => {};

const bind = (method, level) =>
  currentLevel <= level
    ? Function.prototype.bind.call(console[method], console)
    : noop;

const logger = {
  debug: bind('debug', LOG_LEVELS.debug),
  info: bind('info', LOG_LEVELS.info),
  warn: bind('warn', LOG_LEVELS.warn),
  error: bind('error', LOG_LEVELS.error),
};

export default logger;
